import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Button, PageEmptyState, useDevice } from 'seagull';
import { Plus } from 'seagull/icons';
import { useStore, useStoreActions } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { CommonServicesPage } from '../CommonServicesPage/CommonServicesPage';
import { ColumnId, bulkImportRoute } from '../CommonServicesPage/CommonServicesPage.utils';
import EmptyServices from '../emptyServices.svg';
import ServiceLibrarySeeWhatItsLike from './SeeWhatItsLike/SeeWhatItsLike';
const tableDefs = [
    {
        headerItem: {
            value: 'Service name',
            id: ColumnId.Name
        },
        columnDef: {
            width: [
                200,
                400
            ],
            sortable: true,
            mobile: {}
        },
        defaultSortDirection: 'desc'
    },
    {
        headerItem: {
            value: 'Rate',
            id: ColumnId.Rate
        },
        columnDef: {
            width: 130,
            sortable: true,
            mobile: {}
        },
        defaultSortDirection: 'asc'
    },
    {
        headerItem: {
            value: 'Billing occurrence',
            id: ColumnId.BillingOccurance
        },
        columnDef: {
            width: 120,
            sortable: true,
            mobile: {}
        },
        defaultSortDirection: 'desc'
    },
    {
        headerItem: {
            value: 'Billing trigger',
            id: ColumnId.BillingTrigger
        },
        columnDef: {
            width: 110,
            sortable: true
        },
        defaultSortDirection: 'desc'
    }
];
const baseColumnDefs = tableDefs.map((d)=>d.columnDef);
const baseHeaderItems = tableDefs.map((d)=>d.headerItem);
const mobileSortOptions = tableDefs.flatMap((d, colIndex)=>d.columnDef.sortable && d.columnDef.mobile ? [
        {
            id: d.headerItem.id,
            label: d.headerItem.value,
            defaultDirection: d.defaultSortDirection,
            colIndex
        }
    ] : []);
export const importServicesRoute = bulkImportRoute('services');
export function ServicesPage() {
    const importServicesLink = useStore(selectors.filterAvailableRoutes([
        importServicesRoute
    ]))[0];
    const { fetchServiceTemplates } = useStoreActions();
    const { isMobileDevice } = useDevice();
    function renderEmptyState(param) {
        let { openBuilder } = param;
        return /*#__PURE__*/ _jsx(PageEmptyState, {
            maxHeight: true,
            testId: "services-empty",
            illustration: /*#__PURE__*/ _jsx(EmptyServices, {}),
            title: "Organize your business with services",
            message: "Make the process of managing new proposals easier by adding services. You can always create new services, edit or delete existing ones in the future.",
            actions: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !isMobileDevice && /*#__PURE__*/ _jsx(ServiceLibrarySeeWhatItsLike, {}),
                    /*#__PURE__*/ _jsx(Button, {
                        testId: "service-library-new-btn",
                        onClick: ()=>openBuilder(),
                        children: "Create service"
                    })
                ]
            })
        });
    }
    function renderHeaderActions(param) {
        let { openBuilder } = param;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                importServicesLink && /*#__PURE__*/ _jsx(Button, {
                    skin: "primaryOutline",
                    as: Link,
                    to: importServicesLink.url,
                    children: importServicesLink.text
                }),
                /*#__PURE__*/ _jsx(Button, {
                    prefixIcon: /*#__PURE__*/ _jsx(Plus, {
                        size: 18
                    }),
                    testId: "service-library-new-btn",
                    onClick: ()=>openBuilder(),
                    children: "New service"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(CommonServicesPage, {
        title: "Services",
        subtitle: "Create and manage the services you provide to clients. You may customize the services per client when generating each new proposal.",
        columnDefs: baseColumnDefs,
        headerItems: baseHeaderItems,
        fetchMethod: fetchServiceTemplates,
        renderEmptyState: renderEmptyState,
        headerActions: renderHeaderActions,
        mobileSortOptions: mobileSortOptions,
        dataSelector: (state)=>state.serviceTemplates
    });
}
